import { stateful, useEffect, useState } from '@adornis/functional-lit/stateful.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { _subscribeCurrentUser, currentUser, updateCurrentUser } from '@adornis/users/client/currentUser.js';
import { loginWithToken } from '@adornis/users/db/a-user.js';
import { html } from 'lit';
import { filter, firstValueFrom } from 'rxjs';
import * as m from '../../../../localization/out/messages.js';
import { DefaultFullPageLoader } from '../../components/loaders.js';

// Magic-login landing page. Mailed to users with `?token=…`; we exchange the
// token for a session via `User.loginWithToken`, prime the client-side user
// subscription, then bounce to `/`. The main router's role-based redirect
// then lands them on the right dashboard (root for company/admin,
// `/candidate` for candidates).
//
// On invalid/expired tokens we surface a fallback that points the user at
// the regular login page — the OTP "Login mit E-Mail" flow still works.
export const MwActionLogin = stateful(() => {
  const [status, setStatus] = useState<'loading' | 'invalid'>('loading');

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('token');
    if (!token) {
      setStatus('invalid');
      return;
    }

    (async () => {
      try {
        const [userID, userClass] = await loginWithToken(token)();
        updateCurrentUser(undefined, false);
        await _subscribeCurrentUser({ userID, userClass });
        await firstValueFrom(currentUser().whenReady.pipe(filter(Boolean)));
        goTo('/');
      } catch {
        setStatus('invalid');
      }
    })();
  }, []);

  if (status === 'loading') return DefaultFullPageLoader();

  return html`
    <div class="min-h-dvh flex items-center justify-center p-4 bg-base-200">
      <div class="w-full max-w-md card bg-base-100 shadow-xl">
        <div class="card-body">
          <h2 class="card-title">${m.action_login_invalid_title()}</h2>
          <p class="text-sm text-base-content/70">${m.action_login_invalid_desc()}</p>
          <a href="/" class="btn btn-primary mt-2">${m.action_login_to_login()}</a>
        </div>
      </div>
    </div>
  `;
});
